import React, {PureComponent} from 'react'
import styled from 'styled-components'
import { Header, Breadcrumb, Icon, Loader} from '../components'
import {Link} from 'react-router-dom'
import axios from 'axios'
import get from 'lodash/get'
import map from 'lodash/map'
import { toast } from 'react-toastify'
import moment from 'moment'

const Container = styled.div`
  width: 100%;
  padding: 50px 10px 15px 10px; 
  max-width: 800px;
  margin: auto;
`
const Table = styled.table`
  width: 100%;
  background: #fff;
  font-size: 12px;
  border-collapse: collapse;
  & th, td {
   padding: 8px 5px;
   border: 1px solid #e4e4e4;
   &:first-child{
     text-align: center;
   }
}
& thead tr{
  background: #020266 !important;
  color: #fff !important;
  th{
    padding: 10px 5px !important;
  }
  & th:first-child{
    width: 30px;
  }
}
& tr:nth-child(odd){
  background:#fafafa;
  cursor: pointer;
}
& tr:nth-child(even){
  background:#fff;
  cursor: pointer;
}
`
class History extends PureComponent{

  state={
    historyList:[],
    isLoading: true,
  }
  
  componentDidMount=async()=>{
    // state api calls
   await axios.get('/visitor').then(res=> {
    // console.log('response---->', res.data);
    this.setState({historyList:res.data,isLoading: false })
  })
  .catch(err=> {
    toast("Data not found ! ",{
      position: toast.POSITION.BOTTOM_CENTER,
    })
  });

  }


  render(){
    return(
      <React.Fragment>
      <Header/>
      <Container>
        <Breadcrumb>
        <Link to='/'>Home</Link>
        <Icon icon='rightArrow' width={10} height={10}/>
        History 
      </Breadcrumb>
      <Table cellspacing='0' border="1">
        <thead>
          <tr>
            <th>Sr.</th>
            <th>Date</th>
            <th>State</th>
            <th>City</th>
            <th>Houses</th>
            </tr>
        </thead>
        <tbody>
      {this.state.isLoading && <Loader/>}
      {map(this.state.historyList, (item, idx)=> {
        // console.log('items---->>', item)
        return(
          <tr key={idx} onClick={()=> this.props.history.push(`/history/${item.id}`)}>
          <td> {idx+1}. </td>
          <td> {moment(get(item,'createdAt')).format('DD-MMM-YYYY')} </td>
          <td> {get(item,'StateName')} </td>
          <td> {get(item,'CityName')} </td>
          <td> {get(item,'Houses')} </td>
        </tr>
        )
      })}
      </tbody>
      </Table>

      </Container>
      </React.Fragment>
    )
  }
}

export {History}